import { AppBar, Toolbar, Box } from "@mui/material";

export default function Header() {
  return (
    <AppBar position="static" sx={{ backgroundColor: "#ffffff", boxShadow: "0px 2px 5px rgba(0,0,0,0.1)" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        
        {/* Brokancode Logo */}
        <Box component="img"
          src="/brokancode.png"
          alt="Brokancode"
          sx={{ height: 60 }}
        />

        {/* Pharmaron Logo */}
        <Box component="img"
          src="/pharmaron.png"
          alt="Pharmaron"
          sx={{ height: 55 }}
        />

      </Toolbar>
    </AppBar>
  );
}
